// extracted by mini-css-extract-plugin
export default {"tabGdp":"Tab_tabGdp__JXVRz","tabItemGdp":"Tab_tabItemGdp__yE1S7"};